import { useState, useEffect } from "react";
import { FetchRequestTypes, useFetch } from "../../../hooks/useFetch";

export interface CmsMapData {
  mapId: string;
  accessToken: string;
  mapStyle: string;
  pageName: string;
  simpleAddress: string;
  mapType: string;
  zoomOnClose: boolean;
  disableMapChange: boolean;
  mapLayers: CmsMapDataLayer[];
}

export interface CmsMapDataLayer {
  layerId: string;
  layerName: string;
  groupName: string;
  showInFilter: boolean;
  showFromStart: boolean;
  mapNodes: CmsMapDataLayerNode[];
}

export interface CmsMapDataLayerNode {
  nodeId: string;
  zoom?: number;
  pitch?: number;
  bearing?: number;
  body?: string;
}

export const useCmsMapData = (locale: string | null) => {
  const [dataUrl, setDataUrl] = useState<string | null>(null);
  const { data, loading, error } = useFetch(dataUrl, FetchRequestTypes.GET);

  const [cmsMapData, setCmsMapData] = useState<CmsMapData[] | null>(null);

  useEffect(() => {
    if (locale) {
      setDataUrl(`/api/map?lang=${locale || "sv"}`);
    }
  }, [locale]);

  useEffect(() => {
    if (data) {
      const json = JSON.stringify(data);
      setCmsMapData(JSON.parse(json));
    }
  }, [data]);

  useEffect(() => {}, [loading, error]);

  return { cmsMapData, loading, error };
};

